
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import japan from "../../assets/japan.jpg";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function JapanMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Japán magyar fordító</title>
                <meta name='description' content="Ingyenes japán magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Japán magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/japan-magyar-fordito" />
            </Helmet>
            <h1>Japán magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A japán nyelvről</h2>
                    <img src={japan} alt="Japán zászló"></img>
                </div>


                <p>A japán egy kelet-ázsiai nyelv, amelyet körülbelül 128 millió ember beszél Japánban és a japán közösségekben világszerte. Egyedülálló nyelvi szerkezete és írásrendszere teszi a nyelvet tanulmányozásra és felfedezésre érdekes nyelvvé.</p>

                <p>A japán a japoni nyelvcsalád tagja, amelynek nincs egyértelmű genealógiai kapcsolata más nyelvekkel. Viszonylag egyszerű hangrendszer jellemzi, öt magánhangzóval és korlátozott számú mássalhangzóval. A japán kiejtés általában egységes, kevés kivételtől eltekintve.</p>

                <p>A japán írásrendszer három írás kombinációja: kanji, hiragana és katakana. A kanji átvett kínai írásjegyek, amelyeket főnevek, igék és melléknevek jelölésére használnak. A hiragana és a katakana szótagos írásmódok, amelyeket a japán anyanyelvű szavak, nyelvtani elemek és kölcsönszavak jelölésére használnak. A kanji megtanulása a japán nyelvtudás elsajátításának alapvető része, mivel széleskörűen elterjedt használatuk miatt.</p>

                <p>A japán nyelvtan jelentősen különbözik a magyartól és sok más nyelvtől. Ez egy agglutináló nyelv, amiben hasonlít a magyarhoz. Ez azt jelenti, hogy a szavak úgy jönnek létre, hogy az alapszóhoz különböző partikulákat és utótagokat adnak hozzá. A mondat szerkezete alany-tárgy-ige.</p>

                <p>Az udvariasság és a tiszteletadás alapvető szerepet játszik a japán társadalomban és nyelvben. A tisztelet és az udvariassági szintek kifejezésére a társadalmi kontextustól és a beszélők közötti viszonytól függően sajátos szókincs és igealakok használatosak.</p>

                <p>A japán szókincs tartalmaz anyanyelvi eredetű szavakat, valamint kínai, angol és más nyelvekből származó kölcsönszavakat. A japán nyelvnek gazdag költői hagyománya is van, és sok onomatopoétikus szóval él, amelyek szemléletesen írják le a hangokat és jelenségeket.</p>

                <p>A nyelv tanulása hozzáférést biztosít Japán egyedülálló kultúrájához, irodalmához és történelméhez. Lehetővé teszi az olyan hagyományos művészetek mélyebb megértését, mint a teaszertartások, a kalligráfia és a haiku költészet, valamint az olyan modern jelenségek, mint az anime, a manga és a J-pop zene.</p>

                <p>A japán nyelvtudás számos lehetőséghez vezethet olyan területeken, mint az üzleti élet, a turizmus, a kutatás és a fordítás. Japán globális gazdasági erőközpont és a technológiai innováció központja, így a japán nyelvtudás nemzetközi viszonylatban rendkívül értékes.</p>
          
                <div className="sectionbottom">
                    <Link to="/magyar-japan-fordito">Magyar japán fordító</Link>

                    <img src={japan} alt="japán zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
          
          
            </section>
        </>

    )
}

export default JapanMagyar;